import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Apply.css';

const EnquiryForm = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    course: '',
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const valid = Object.values(formData).every((v) => v.trim() !== '');
    setIsFormValid(valid);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://ptlrbackend.onrender.com/api/submit', formData);
      setSuccessMessage(res.data.message || 'Form submitted successfully!');
      setErrorMessage('');
      setFormData({ firstname: '', lastname: '', email: '', phone: '', course: '' });
      setTimeout(() => closeModal(), 2000);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || 'Error submitting the form.');
      setSuccessMessage('');
    }
  };

  return (
    <div className="enquiry-modal__overlay">
      <div className="enquiry-modal__content">
        <button className="enquiry-modal__close-btn" onClick={closeModal}>&times;</button>
        <h2 className="enquiry-modal__title">Enquiry Form</h2>

        {successMessage && <p className="enquiry-modal__success">{successMessage}</p>}
        {errorMessage && <p className="enquiry-modal__error">{errorMessage}</p>}

        <form onSubmit={handleSubmit} className="enquiry-form">
          <div className="enquiry-form__group">
            <input
              type="text"
              name="firstname"
              className="enquiry-form__input"
              placeholder="First Name"
              value={formData.firstname}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="enquiry-form__group">
            <input
              type="text"
              name="lastname"
              className="enquiry-form__input"
              placeholder="Last Name"
              value={formData.lastname}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="enquiry-form__group">
            <input
              type="email"
              name="email"
              className="enquiry-form__input"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="enquiry-form__group">
            <input
              type="text"
              name="phone"
              className="enquiry-form__input"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="enquiry-form__group">
            <select
              name="course"
              className="enquiry-form__select"
              value={formData.course}
              onChange={handleInputChange}
              required
            >
              <option value="">Choose Course</option>
              <option value="Diploma">Diploma</option>
              <option value="M.Tech">M.Tech</option>
              <option value="B.Tech">B.Tech</option>
            </select>
          </div>
          <button type="submit" className="enquiry-form__submit" disabled={!isFormValid}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquiryForm;
